import { z } from 'my-zod'

export const gearUsageFragment = z.object({
  GearId: z.number().nullish(),
  CheckInCount: z.number().nullish(),
  CheckOutCount: z.number().nullish()
})

export type gearUsageFragment = z.infer<typeof gearUsageFragment>
